let Claims = (function () {
    const statusSelect = '#status';
    const rejectionFormUrl = '/shop/claims/reason_form';
    const reasonForm = $('#reason_form');
    const rejectedStatus = reasonForm.data('rejected_status');
    const currentStatus = reasonForm.data('current_status');

    let init = () => {
        listenChangeStatus();
    };

    let listenChangeStatus = () => {
        $(document).on('change', statusSelect, function () {
            let newStatus = $(this).val();
            if (newStatusIsRejected(newStatus)) {
                showRejectionForm();
            } else {
                removeRejectionForm();
            }
        });
    };

    let showRejectionForm = () => {
        $.get(rejectionFormUrl, function (data) {
            reasonForm.html(data.reason_form);
        });
    };

    let removeRejectionForm = () => {
        reasonForm.html('');
    };

    let newStatusIsRejected = (newStatus) => {
        return currentStatus != rejectedStatus && newStatus == rejectedStatus;
    };

    return {
        init: init
    }
})();

export default Claims;
